import { Request } from 'express';
import { RateLimitConfig } from '../types/types';
import { ipKeyGeneratorFromReq } from '../utils/ipKeyHelpers';

export const rateLimitConfigs: Record<string, RateLimitConfig> = {
  development: {
    api: { windowMs: 15 * 60 * 1000, max: 1000, standardHeaders: true, legacyHeaders: false },
    auth: { windowMs: 15 * 60 * 1000, max: 50, standardHeaders: true, legacyHeaders: false },
    sensitive: { windowMs: 15 * 60 * 1000, max: 20, standardHeaders: true, legacyHeaders: false }
  },
  production: {
    api: {
      windowMs: 15 * 60 * 1000,
      max: 300,
      standardHeaders: true,
      legacyHeaders: false,
      keyGenerator: (req: Request) => ipKeyGeneratorFromReq(req) 
    },
    auth: {
      windowMs: 15 * 60 * 1000,
      max: 20,
      standardHeaders: true,
      legacyHeaders: false,
      keyGenerator: (req: Request) => ipKeyGeneratorFromReq(req)
    },
    sensitive: {
      windowMs: 60 * 60 * 1000,
      max: 10,
      standardHeaders: true,
      legacyHeaders: false,
      keyGenerator: (req: Request) => ipKeyGeneratorFromReq(req)
    }
  }
};
